import { render, staticRenderFns } from "./material-table-info.vue?vue&type=template&id=31a5a60c&scoped=true"
import script from "./material-table-info.vue?vue&type=script&setup=true&lang=js"
export * from "./material-table-info.vue?vue&type=script&setup=true&lang=js"
import style0 from "./material-table-info.vue?vue&type=style&index=0&id=31a5a60c&prod&lang=scss"
import style1 from "./material-table-info.vue?vue&type=style&index=1&id=31a5a60c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a5a60c",
  null
  
)

export default component.exports